// apiUtils.js
import axios from "axios";

const BASE_URL =
  "https://zwpkkub3s8.execute-api.ap-south-1.amazonaws.com/default/";

export const sendOtp = async (mobileNumber) => {
  try {
    const payload = JSON.stringify({
      phoneNumber: "91" + mobileNumber,
      broker: "acagarwal",
      orderId: null,
      otp: null,
    });

    const response = await axios.post(`${BASE_URL}og_sendverify_otp`, payload, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (error) {
    console.error("Error sending OTP:", error);
    throw error;
  }
};

export const verifyOtp = async (mobileNumber, orderId, otp) => {
  try {
    const payload = JSON.stringify({
      phoneNumber: "91" + mobileNumber,
      broker: "acagarwal",
      orderId: orderId,
      otp: otp,
    });

    const response = await axios.post(`${BASE_URL}og_sendverify_otp`, payload, {
      headers: { "Content-Type": "application/json" },
    });

    console.log("Response from Step 3:", response);

    // for step 4
    const { user_id, new_user } = response.data;

    return response.data;
  } catch (error) {
    console.error("Error verifying OTP:", error);
    throw error;
  }
};

export const resendOtp = async (mobileNumber, orderId) => {
  try {
    const payload = JSON.stringify({
      phoneNumber: "91" + mobileNumber,
      broker: "acagarwal",
      orderId: orderId,
      otp: null,
    });

    const response = await axios.post(`${BASE_URL}og_sendverify_otp`, payload, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (error) {
    console.error("Error resending OTP:", error);
    throw error;
  }
};

export const connectToDashboard = async (payload) => {
  try {
    const response = await axios.post(
      `https://cgcxpd7eql.execute-api.ap-south-1.amazonaws.com/default/og_acagarwal_token_generation`,
      JSON.stringify(payload),
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    console.log("Response from Step 4:", response);

    // saving in ls
    // console.log(response.data);
    const { access_token, ws_token, client_id } = response.data;
    Object.keys({ access_token, ws_token, client_id }).forEach((key) => {
      localStorage.setItem(key, response.data[key]);
    });

    return response.data;
  } catch (error) {
    console.error("Error connecting to dashboard:", error);
    throw error;
  }
};

// Axis Bank login flow functions
export const fetchAxisLoginDetails = async () => {
  try {
    const response = await axios.post(
      'https://x4exd50246.execute-api.ap-south-1.amazonaws.com/default/og_axis_loginurl',
      {},
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    const { redirectURL, public_key } = response.data;

    // Store public key in localStorage
    localStorage.setItem('axis_public_key', public_key);

    return { redirectURL, publicKey: public_key };
  } catch (error) {
    console.error("Error fetching Axis login details:", error);
    throw error;
  }
};

export const generateAxisToken = async (ssoId) => {
  try {
    const publicKey = localStorage.getItem('axis_public_key');

    if (!publicKey) {
      throw new Error('Public key not found. Please restart the login process.');
    }

    const payload = {
      ssoId: ssoId,
      public_key: publicKey
    };

    const response = await axios.post(
      'https://372k3vkr24.execute-api.ap-south-1.amazonaws.com/default/og_axis_generatetoken',
      JSON.stringify(payload),
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (response.data.stat === "OK") {
      const { auth_code, access_token, ws_access_token, user_id } = response.data.body;

      // Store tokens in localStorage
      const tokenData = {
        axis_auth_code: auth_code,
        axis_access_token: access_token,
        axis_ws_access_token: ws_access_token,
        axis_user_id: user_id
      };

      Object.keys(tokenData).forEach((key) => {
        localStorage.setItem(key, tokenData[key]);
      });

      return response.data.body;
    } else {
      throw new Error('Token generation failed');
    }
  } catch (error) {
    console.error("Error generating Axis token:", error);
    throw error;
  }
};
